import { FC, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import Grid from "@mui/material/Grid";
import { PdfData } from "@/models/pdfData";
import { FillerData } from "@/models/pdfModels";
import { useResponsiveContext } from "@context/ResponsiveContext";

const CompleteGameDataDialog: FC<{
  open: boolean;
  game: PdfData;
  handleClose: () => void;
  onCreateGame: (game: FillerData["data"]) => void;
}> = ({ open, handleClose, onCreateGame, game }) => {
  const { onMobile } = useResponsiveContext();

  const [location, setLocation] = useState(game.gameData.location);
  const [gameNumber, setGameNumber] = useState(game.gameData.gameNumber);

  const handleSubmit = () => {
    if (location && gameNumber) {
      onCreateGame({
        ...game,
        gameData: {
          ...game.gameData,
          location: location,
          gameNumber: gameNumber,
        },
      });
    } else {
      console.error("Location or gameNumber not set when trying to submit!", {
        location,
        gameNumber,
      });
    }
  };

  return (
    <Dialog
      open={open}
      fullWidth={true}
      fullScreen={onMobile}
      maxWidth={"sm"}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>Daten vervollständigen</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} columns={12} pt={3}>
          <Grid size={7}>
            <TextField
              required
              margin="dense"
              label="Spielnummer"
              id="gameNumber"
              type="text"
              fullWidth
              value={gameNumber}
              onChange={(event) => setGameNumber(event.target.value)}
              variant="outlined"
              sx={{ mt: 0 }}
            />
          </Grid>
          <Grid size={12}>
            <TextField
              required
              margin="dense"
              id="location"
              label="Spielhalle"
              type="text"
              fullWidth
              value={location}
              onChange={(event) => setLocation(event.target.value)}
              variant="outlined"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Abbrechen</Button>
        <Button disabled={!(location && gameNumber)} onClick={handleSubmit}>
          Speichern
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CompleteGameDataDialog;
